import { useMemo } from 'react';
import { useTranslation } from 'next-i18next';

const useDealsListingCMSData = () => {
  const { t } = useTranslation();

  const data = useMemo(
    () => ({
      data: {
        DealsListingPage: {
          heroBackground: {
            small_url: {
              url: '/imgs/Rebranding/deals/deals-hero-SM.jpg',
            },
            medium_url: {
              url: '/imgs/Rebranding/deals/deals-hero-MD.jpg',
            },
            large_url: {
              url: '/imgs/Rebranding/deals/deals-hero-LG.jpg',
            },
            xlarge_url: {
              url: '/imgs/Rebranding/deals/deals-hero-XL.jpg',
            },
            alt: 'deals Page Background',
          },
          patternBackground: {
            small_url: {
              url: '/imgs/Rebranding/location-module/asphalt_bg.jpg',
            },
            medium_url: {
              url: '/imgs/Rebranding/location-module/asphalt_bg.jpg',
            },
            large_url: {
              url: '/imgs/Rebranding/location-module/asphalt_bg.jpg',
            },
            xlarge_url: {
              url: '/imgs/Rebranding/location-module/asphalt_bg.jpg',
            },
            alt: 'pattern Background',
          },
          heroSubtitle: t('deals_listing:hero_subtitle'),
          allLocationsLabel: t('deals_listing:all_locations'),
          offLabel: t('deals_listing:off'),
          perDayLabel: t('deals_listing:per_day'),
          buyOneGetOneLabel: t('deals_listing:buy_1_day_get_1_day'),
          defaultTitle: t('deals_listing:default_title'),
          locationSelectedLabel: t('deals_listing:location_selected'),
          typeSelectedLabel: t('deals_listing:type_selected'),
          locationTypeSelectedLabel: t('deals_listing:location_type_selected'),
          eagleRiderLabel: t('deals_listing:eagle_rider'),
          saveLabel: t('deals_listing:save'),
          upToLabel: t('deals_listing:up_to'),
          rentalsToursLabel: t('deals_listing:rentals_tours'),
          joinClubLabel: t('deals_listing:join_club'),
          unlockSavingsLabel: t('deals_listing:unlock_savings'),
          clickHereLabel: t('deals_listing:click_here'),
          moreThanLabel: t('deals_listing:more_than'),
          onMotorcycleRentalsLabel: t('deals_listing:on_motorcycle_rentals'),
          promoDealTitle: t('deals_listing:promo_tite'),
          promoDealDescription: t('deals_listing:promo_desc'),
          PromoDealIdentifier: t('deals_listing:promo_slug'),
          promoBtn: t('deals_listing:promo_btn'),
          promoImage: {
            small_url: {
              url: '/imgs/Rebranding/deals/deal_promo_sm.jpg',
            },
            medium_url: {
              url: '/imgs/Rebranding/deals/deal_promo_md.jpg',
            },
            large_url: {
              url: '/imgs/Rebranding/deals/deal_promo_lg.jpg',
            },
            xlarge_url: {
              url: '/imgs/Rebranding/deals/deal_promo_xl.jpg',
            },
            alt: t('deals_listing:promo_tite'),
          },
          promoSubImage: {
            small_url: {
              url: '/imgs/Rebranding/deals/sub_promo_sm.jpg',
            },
            medium_url: {
              url: '/imgs/Rebranding/deals/sub_promo_lg.jpg',
            },
            large_url: {
              url: '/imgs/Rebranding/deals/sub_promo_lg.jpg',
            },
            xlarge_url: {
              url: '/imgs/Rebranding/deals/sub_promo_lg.jpg',
            },
            alt: t('deals_listing:promo_tite'),
          },
        },
        DealCardComponent: {
          off: t('common_deal_card:off'),
          offAmount: t('common_deal_card:off_amount'),
          day: t('common_deal_card:day'),
          bego: t('common_deal_card:bego'),
          oneWaySpecial: t('common_deal_card:one_way_special'),
          buyOneDayGetOneLabel: t('common_deal_card:by_one_get_one'),
          buyXDaysGetYDaysFreeLabel: t('common_deal_card:buy_x_days_get_y_days_free'),
          dealDaySingular: t('common_deal_card:deal_day', { count: 1 }),
          dealDayPlural: t('common_deal_card:deal_day', { count: 2 }),
          learnMoreBtnLabel: t('common_deal_card:learn_more'),
        },
      },
    }),
    [t],
  );

  return data;
};

export { useDealsListingCMSData };
